import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { VistaPrevia } from './components/VistaPrevia';
import { PainPoints } from './components/PainPoints';
import { Audience } from './components/Audience';
import { StatsAndSituations } from './components/StatsAndSituations';
import { TomosAccordion } from './components/TomosAccordion';
import { BonosGrid } from './components/BonosGrid';
import { CostComparison } from './components/CostComparison';
import { Pricing } from './components/Pricing';
import { UpgradeElite } from './components/UpgradeElite';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Urgency } from './components/Urgency';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel safely
    const f = window as any;
    if (f.fbq) return;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    // @ts-ignore
    fbq('init', '937331855399019');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-orange-500/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <SocialProof data-id="element-3" />
        <VistaPrevia data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Audience data-id="element-6" />
        <StatsAndSituations data-id="element-7" />
        <TomosAccordion data-id="element-8" />
        <BonosGrid data-id="element-9" />
        <CostComparison data-id="element-10" />
        <Pricing data-id="element-11" />
        <UpgradeElite data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <Urgency data-id="element-15" />
        <Pricing data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}